import React from 'react'
import { Checkbox, Select, Tooltip } from 'antd'

export interface SurgicalCellProps {
  isSurgical: boolean | null
  autoIsSurgical: boolean | null
  onChange: (value: boolean | null) => void
  editable?: boolean
}

export const SurgicalCell: React.FC<SurgicalCellProps> = ({
  isSurgical,
  autoIsSurgical,
  onChange,
  editable = true,
}) => {
  const isManual = isSurgical !== null
  const displayValue = isSurgical ?? autoIsSurgical ?? false

  const tooltipText = isManual
    ? `Ручной выбор: ${isSurgical ? 'Да' : 'Нет'}\nАвтоклассификация: ${autoIsSurgical ? 'Да' : 'Нет'}`
    : `Автоклассификация: ${autoIsSurgical ? 'Да' : 'Нет'}`

  return (
    <Tooltip title={tooltipText} placement="top">
      <Checkbox
        checked={displayValue}
        onChange={(e) => {
          if (!editable) return
          const newVal = e.target.checked
          // If matches auto — set to null (remove manual override)
          if (newVal === autoIsSurgical) {
            onChange(null)
          } else {
            onChange(newVal)
          }
        }}
        disabled={!editable}
        style={isManual ? { fontWeight: 'bold' } : { opacity: 0.7 }}
      />
    </Tooltip>
  )
}

// --- ProfileTypeDetailedCell ---

const PROFIL_TYPE_LABELS: Record<string, string> = {
  surgical: 'Хирург.',
  therapeutic: 'Терапевт.',
  resuscitation: 'АРО/ОРИТ',
  rehabilitation: 'Реабилит.',
  oncology: 'Онкология',
  palliative: 'Паллиатив',
}

const PROFIL_TYPE_OPTIONS = Object.entries(PROFIL_TYPE_LABELS).map(([value, label]) => ({
  value,
  label,
}))

export interface ProfileTypeDetailedCellProps {
  value: string | null
  autoValue: string | null
  onChange: (value: string | null) => void
  editable?: boolean
}

export const ProfileTypeDetailedCell: React.FC<ProfileTypeDetailedCellProps> = ({
  value,
  autoValue,
  onChange,
  editable = true,
}) => {
  const displayValue = value || autoValue || ''
  const isManual = value !== null && value !== autoValue

  const tooltipText = isManual
    ? `Ручной: ${PROFIL_TYPE_LABELS[value!] || value}\nАвто: ${PROFIL_TYPE_LABELS[autoValue || ''] || autoValue || '—'}`
    : `Авто: ${PROFIL_TYPE_LABELS[autoValue || ''] || autoValue || '—'}`

  if (!editable) {
    return (
      <Tooltip title={tooltipText}>
        <span style={isManual ? { fontWeight: 'bold' } : { opacity: 0.7 }}>
          {PROFIL_TYPE_LABELS[displayValue] || displayValue || '—'}
        </span>
      </Tooltip>
    )
  }

  return (
    <Tooltip title={tooltipText} placement="top">
      <Select
        value={displayValue || undefined}
        onChange={(val) => {
          // If matches auto — clear manual override
          if (val === autoValue) {
            onChange(null)
          } else {
            onChange(val)
          }
        }}
        options={PROFIL_TYPE_OPTIONS}
        size="small"
        style={{
          width: 110,
          fontWeight: isManual ? 'bold' : 'normal',
          opacity: isManual ? 1 : 0.7,
        }}
        variant="borderless"
      />
    </Tooltip>
  )
}
